import React, { useState } from 'react';
import backendAPI from '../api/backendApi'; // ✅ Correct import

const SignUpPage = ({ onSignup, onSwitchToLogin }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Simple validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setLoading(false);
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters');
      setLoading(false);
      return;
    }

    try {
      const response = await backendAPI.registerUser({ // ✅ Use class method
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        password: formData.password
      });

      if (response.success) {
        // Auto-login after successful registration
        const user = {
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          username: `${formData.firstName} ${formData.lastName}`
        };
        onSignup(user, response.token);
      } else {
        setError(response.error);
      }
    } catch (error) {
      setError('Registration failed: ' + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="signup-page">
      <h1>SportIQ Sign Up</h1>
      
      <form onSubmit={handleSubmit} className="auth-form">
        <div className="form-group">
          <label>First Name:</label>
          <input 
            type="text" 
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Last Name:</label>
          <input 
            type="text" 
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Email:</label>
          <input 
            type="email" 
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className="form-group">
          <label>Password:</label>
          <input 
            type="password" 
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            minLength="6"
          />
        </div>
        
        <div className="form-group">
          <label>Confirm Password:</label>
          <input 
            type="password" 
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <button type="submit" disabled={loading} className="submit-btn">
          {loading ? 'Creating Account...' : 'Sign Up'}
        </button>
      </form>
      
      <p className="switch-auth">
        Already have an account? 
        <button onClick={onSwitchToLogin} className="link-btn">Login</button>
      </p>
    </div>
  );
};

export default SignUpPage;
